import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { AIDefinitionsPluginState } from './types';

export const aiDefinitionsPluginKey = new PluginKey<AIDefinitionsPluginState>('aiDefinitions');
